import OpeningTimes from './OpeningTimes';

export default OpeningTimes;
